// src/App.jsx
import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { CssBaseline, ThemeProvider, Box } from "@mui/material";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ColorModeContext, useMode } from "./theme";
import { AuthProvider, useAuth } from "./authContext/AuthContext";

import Sidebar from "./scenes/global/Sidebar";
import DashboardMIS from "./scenes/DashboardMIS";
import LiquidOffice from "./scenes/liquidoffice";
import InvSep from "./scenes/invsep_tracking";
import Payroll from "./scenes/payroll";
import Login from "./scenes/login";
import UsersPage from "./scenes/users";

const RequireAuth = ({ children }) => {
    const { user } = useAuth();
    return user ? children : <Navigate to="/login" replace />;
};

const RequireAdmin = ({ children }) => {
    const { user } = useAuth();
    return user && user.roleId === 1 ? children : <Navigate to="/" replace />;
};

const ProtectedLayout = () => (
    <Box sx={{ display: "flex", height: "100vh" }}>
        <Sidebar />
        <Box sx={{ flex: 1 }}>
            <Outlet />
        </Box>
    </Box>
);

const AppContent = () => {
    const [theme, colorMode] = useMode();

    return (
        <DndProvider backend={HTML5Backend}>
            <ColorModeContext.Provider value={colorMode}>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route element={<RequireAuth><ProtectedLayout /></RequireAuth>}>
                            <Route path="/" element={<DashboardMIS />} />
                            <Route path="/liquidoffice" element={<LiquidOffice />} />
                            <Route path="/invsep_tracking" element={<InvSep />} />
                            <Route path="/payroll" element={<Payroll />} />
                            <Route path="/users" element={<RequireAdmin><UsersPage /></RequireAdmin>} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </ThemeProvider>
            </ColorModeContext.Provider>
        </DndProvider>
    );
};

export default function App() {
    return (
        <AuthProvider>
            <AppContent />
        </AuthProvider>
    );
}
